import createApiServices from "./createApiServices"
import {extendUrlFulfillment} from "../../views/helpers/extenent-url"

const prefixURL = `${extendUrlFulfillment.url}/api` || 'https://fulfillment-staging.merchize.com/api'
const api = createApiServices({baseUrl: prefixURL})

export const getListRequests = (data) => {
    return api.makeAuthRequest({
        url: '/platform/list-request/search',
        method: 'POST',
        data,
    })
}

export const exportListRequests = (data) => {
    return api.makeAuthRequest({
        url: '/export-order/list-request/export',
        method: 'POST',
        data,
    })
}